import { defineComponent as _defineComponent } from 'vue'
import ShokurekishoJobHistoryCard from '@/components/format-edit/shokurekisho/ShokurekishoJobHistoryCard.vue'
import type { BasicData } from '@/utils/format-edit/basicData'


export default /*#__PURE__*/_defineComponent({
  __name: 'ShokurekishoSkillsheetJobHistoryCard',
  props: {
    currentCardId: null,
    basicData: null
  },
  setup(__props: any) {



const skillsheetLead =
  '今までのプロジェクトの概要を入力しましょう\nプロジェクト名、期間、業務内容、体制、使用したツールやソフトウェアなど具体的に入力しましょう'

return { __sfc: true,skillsheetLead, ShokurekishoJobHistoryCard }
}

})